export default __webpack_public_path__ + "static/media/shipment-activity-pickup.4dfe44e5.svg";